import { call, put, takeLatest, select, take } from "redux-saga/effects";
import { push } from "redux-little-router";
import { startSubmit, stopSubmit, getFormValues, initialize } from "redux-form";
import mixpanel from "../services/mixpanel";
import api from "../api/api";
import * as CollectionApi from "../api/CollectionApi";
import { showAlert } from "../actions";
import {
  deleteCollectionFailed,
  createCollectionSuccess,
  editCollectionSuccess,
  closeCollectionFormModal,
  addPostToCollectionFailed,
  openAddToCollectionModal,
  closeAddToCollectionModal,
} from "../actions/collectionActions";
import { selectUser } from "../util/selectors";
import { collectionFormModalTriggerSources } from "../constants";

function* handleCreateCollectionSuccess(newCollection) {
  yield put(createCollectionSuccess(newCollection.data));

  yield put(closeCollectionFormModal());
  yield put(stopSubmit("collectionModalForm"));
  yield put(showAlert("Collection created successfully"));
}

function* handleCreateCollectionToAddPostSuccess() {
  yield put(closeCollectionFormModal());
  const postId = yield select(state => state.ui.addToCollectionModal.postId);
  yield put(openAddToCollectionModal(postId));
}

function* submitCollectionFormModal() {
  yield put(startSubmit("collectionModalForm"));
  const collectionData = yield select(getFormValues("collectionModalForm"));

  let request = CollectionApi.getCreateCollectionUrl(collectionData);
  return yield call(api.post, request.url, request.config);
}

function* handleCreateCollectionRequests() {
  yield take("@@redux-form/SUBMIT");
  try {
    const newCollection = yield submitCollectionFormModal();

    const requestSource = yield select(state => state.ui.collectionFormModal.source);

    if (requestSource === collectionFormModalTriggerSources.COLLECTIONS_PAGE) {
      yield handleCreateCollectionSuccess(newCollection);
    } else if (requestSource === collectionFormModalTriggerSources.ADD_TO_COLLECTION_MODAL) {
      yield handleCreateCollectionToAddPostSuccess();
    }

    mixpanel.track("addNewCollection.success", {
      collectionId: newCollection.data._id,
      collectionName: newCollection.data.name,
    });
  } catch (error) {
    const errorObject = { _error: "Unexpected error occurred, please try again." };
    yield put(stopSubmit("collectionModalForm", errorObject));
  }
}

function* handleEditCollectionRequests() {
  const collectionName = yield select(state => state.collections.current.name);
  yield put(initialize("collectionModalForm", { collectionName }));
  yield take("@@redux-form/SUBMIT");

  yield put(startSubmit("collectionModalForm"));
  const collectionData = yield select(getFormValues("collectionModalForm"));
  const collectionId = yield select(state => state.collections.current._id);

  let request = CollectionApi.getEditCollectionUrl(collectionId, collectionData);
  try {
    yield call(api.put, request.url, request.config);
    yield put(editCollectionSuccess(collectionData));

    mixpanel.track("collection.edit", { collectionId });

    yield put(closeCollectionFormModal());
    yield put(stopSubmit("collectionModalForm"));
    yield put(showAlert("Collection edited successfully"));
  } catch (error) {
    const errorObject = { _error: "Unexpected error occurred, please try again." };
    yield put(stopSubmit("collectionModalForm", errorObject));
  }
}

function* handleDeleteCollectionRequests({ collectionId }) {
  const request = CollectionApi.getDeleteCollectionUrl(collectionId);

  try {
    yield call(api.delete, request.url);
    const loggedInUser = yield select(selectUser);
    yield put(showAlert("Collection deleted successfully"));
    yield put(push(`/profile/${loggedInUser.uid}/collections`));

    mixpanel.track("collection.delete", { collectionId });
  } catch (error) {
    yield put(deleteCollectionFailed(collectionId));
    yield put(showAlert("Couldn't delete the collection", "error"));
  }
}

function* handleAddPostToCollectionRequests({ postId, collectionId }) {
  const request = CollectionApi.getAddPostToCollectionUrl({ postId, collectionId });

  try {
    yield call(api.post, request.url, request.config);
    yield put(showAlert("Post addedd to collection successfully"));
    yield put(closeAddToCollectionModal());
    mixpanel.track("addToCollection", { postId, collectionId });
  } catch (error) {
    yield put(addPostToCollectionFailed(collectionId));
    yield put(showAlert("Couldn't add the post to the collection", "error"));
  }
}

export function* watchCollectionRequests() {
  yield takeLatest("OPEN_NEW_COLLECTION_FORM_MODAL", handleCreateCollectionRequests);
  yield takeLatest("OPEN_EDIT_COLLECTION_FORM_MODAL", handleEditCollectionRequests);
  yield takeLatest("DELETE_COLLECTION_REQUEST", handleDeleteCollectionRequests);
  yield takeLatest("ADD_POST_TO_COLLECTION_REQUEST", handleAddPostToCollectionRequests);
}

export default watchCollectionRequests;



// WEBPACK FOOTER //
// ./src/sagas/CollectionSaga.js